import {Button} from 'antd';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';

const ThirdSection = ({data}) => {
  return (
    <div className={'w-full flex justify-center items-center lg:px-20 px-5 py-4'}>
      <div className={'grid lg:grid-cols-2 grid-cols-1 lg:gap-0 gap-3 max-w-7xl'}>
        <div>
          <h1 className={'playfair-display-medium font-bold lg:text-6xl text-4xl text-secondary-300'}>{data.title}</h1>
          <p className={'mt-7 font-sans lg:w-2/3 text-justify text-lg'}>{data.description}</p>
          <Link to={'/contact-us'}>
            <div className={'mt-6 flex gap-4 items-center'}>
              <Button className={'!bg-secondary-300 !text-white w-36 h-10 font-semibold'}>{data.buttonText}</Button>
            </div>
          </Link>
        </div>
        <div>
          <div className={'lg:h-[420px] h-96 lg:curved-image curved-image1'}>
            <img src={data.image} alt={'home'} className={'object-cover w-full h-full '}></img>
          </div>
        </div>
      </div>
    </div>
  );
};

ThirdSection.propTypes = {
  data: PropTypes.shape,
};

export default ThirdSection;
